export enum PaymentRequestStatus {
  Submitted = 1,
  Approved = 2,
  Rejected = 3,
  SentForPayment = 4,
  Returned = 5,
  Draft = 6,
  Paid = 7
}

export default PaymentRequestStatus;
